import React, { useState, useEffect } from "react";
import { StyledButton } from "../../../common/components/Button";
import jsPDF from "jspdf";
import "jspdf-autotable";
import TreatmentQuote from "../../../common/components/InvoiceTemplates/TreatmentQuote";
import { renderToString } from "react-dom/server";
import { getAllTermsOfPaymentByType } from "../../../api/termsOfPaymentApi";
import { Dialog, DialogActions, DialogTitle, Box } from "@mui/material";
import { getTreatmentTypes } from "../../../api/treatmentTypesApi";
import { updateCaseTreatmentTypeAmount } from "../../../api/caseApi";
import {
  DialogContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
const ReportGenerator = ({
  getCaseData,
  caseDetails,
  totalAmountPaid,
  isDownpaymentPaid,
}) => {
  const [termsOfPaymentAfterDesign, setTermsOfPaymentAfterDesign] = useState(
    []
  );
  const [downPayment, setDownPayment] = useState(null);
  const [openListOfTreatmentTypes, setOpenListOfTreatmentTypes] =
    useState(false);

  const [treatmentType, setTreatmentType] = useState(null);

  const [listOfTreatmentTypes, setListOfTreatmentTypes] = useState([]);

  useEffect(() => {
    fetchTermsOfPayments();
  }, []);

  const handleSubmitChangeCaseTotalPrice = async (data) => {
    const response = await updateCaseTreatmentTypeAmount({
      caseId: caseDetails.id,
      treatmentTypeId: data.id,
      amount: data.totalPayment,
    });
    constructInvoice(response.data);
    setOpenListOfTreatmentTypes(false);
    getCaseData();
  };

  const handleChangeCaseTotalPrice = (data) => {
    setTreatmentType(data);
  };

  const fetchTermsOfPayments = async () => {
    const response1 = await getAllTermsOfPaymentByType(1);
    const filteredTOP = response1.filter((x) => {
      return x.paymentSchedules[0].step === 4;
    });

    setTermsOfPaymentAfterDesign([...filteredTOP]);

    const response2 = await getAllTermsOfPaymentByType(0);

    const filteredDP = response2.filter((x) => {
      return x.name.toLowerCase() === "downpayment";
    });
    setDownPayment(filteredDP[0]);
  };

  const constructInvoice = (caseDetails) => {
    console.log(treatmentType);
    const doc = new jsPDF("p", "px", "a4");

    const htmlToString = renderToString(
      TreatmentQuote(
        caseDetails,
        totalAmountPaid,
        downPayment,
        termsOfPaymentAfterDesign,
        isDownpaymentPaid
      )
    );
    doc.html(htmlToString, {
      margin: [20, 20, 20, 20],
      autoPaging: "text",
      x: 0,
      y: 0,
      width: 655,
      windowWidth: 675,

      callback: function (doc) {
        doc.save(
          caseDetails.patient.firstName +
            "_" +
            caseDetails.patient.lastName +
            "_Invoice.pdf"
        );
      },
    });
  };

  const checkCaseDetails = async () => {
    if (
      caseDetails.treatmentTypeId == null ||
      caseDetails.treatmentTypeTotalAmount === 0
    ) {
      const response = await getTreatmentTypes();
      setListOfTreatmentTypes(response);
      if (response.length > 1) {
        setOpenListOfTreatmentTypes(true);
      } else {
        handleSubmitChangeCaseTotalPrice(response[0]);
      }
    } else {
      console.log("asdf");
      constructInvoice(caseDetails);
      setOpenListOfTreatmentTypes(false);
    }
  };
  return (
    <>
      <Dialog
        open={openListOfTreatmentTypes}
        onClose={() => setOpenListOfTreatmentTypes(false)}
      >
        <DialogTitle>Choose Treatment Type</DialogTitle>
        <DialogContent>
          <Box margin={"5px"}>
            <FormControl>
              <InputLabel>Treatment Types</InputLabel>
              <Select
                label="Treatment Types"
                style={{ width: "300px" }}
                onChange={(e) => handleChangeCaseTotalPrice(e.target.value)}
              >
                {listOfTreatmentTypes.map((t, idx) => {
                  return (
                    <MenuItem value={t} key={idx}>
                      {t.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <StyledButton
            theme="purple"
            onClick={() => setOpenListOfTreatmentTypes(false)}
          >
            Cancel
          </StyledButton>
          <StyledButton
            theme="green"
            onClick={() => handleSubmitChangeCaseTotalPrice(treatmentType)}
          >
            Submit
          </StyledButton>
        </DialogActions>
      </Dialog>
      <StyledButton onClick={checkCaseDetails} theme="green">
        Generate Invoice
      </StyledButton>
    </>
  );
};

export default ReportGenerator;
